import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ModuleTypeIcon = (props) => {
  if (props.moduleType === "Scorm") {
    return (
      <div title="Scorm" className="float-start me-4">
        <FontAwesomeIcon icon="cloud" size="2x" className="text-primary" />
        <FontAwesomeIcon
          icon="bolt"
          size="sm"
          className="text-light"
          style={{ marginLeft: "-20px" }}
        />
      </div>
    );
  } else {
    return (
      <div className="float-start me-4">
        <img
          alt="course icon"
          src="img/learnwareloggo.png"
          style={{ maxHeight: "25px" }}
        />
      </div>
    );
  }
};

export default ModuleTypeIcon;
